import ConditionHandler from "./ConditionHandler";
import EffectHandler from "./EffectHandler";
import DataStore from "./../stores/DataStore";

/**
 * @class
 * Klasse, welche genau eine Attributabhängigkeit, bestehend aus einer Condition sowieo einem Effekt, handlet.
 * Wenn die Condition erfüllt ist, soll der Effekt getriggert werden (Ein/Ausblenden von Attributen, Nachrichten, Notwendigkeit vpon Attributen)
 * Wenn eine Condition nicht erfüllt ist, soll der Effekt rückgängig gemacht werden.
 * Es werden keine Widersprüchlichen Abhängigkeiten oder Verschachtelten Abhängigkeiten berücksichtigt oder irgendwie geregelt.
 */
class Dependency {
  /**
   * @constructor
   * @param {Dependency} dependency
   * @param {ConditionHandler} dependency.triggerCondition Bedingung
   * @param {EffectHandler[]} dependency.effects Effekte
   */
  constructor(params) {
    const { triggerCondition = undefined, effects = [] } = params;
    this.triggerConditionConfig = triggerCondition;
    this.effectsConfig = effects;
    this.effects = [];
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.buildCondition();
    this.buildEffects();
  }

  /**
   *  @function Dependency.prepareConditionConfigs Funktion, welche die Konfigurationen für die einzelnen Condition vorberietet. Beispielsweise wird die Konfiguration benannter Conditions an Stellen übertragen, wo diese wieder genutzt werden, um Konfigurationsoverhead beim etellen zu vermeiden.
   */
  prepareConditionConfigs() {}

  /**
   *  @function Dependency.buildCondition Funktion, die (teilweise rekursiv) die Condition erstellt.
   */
  buildCondition() {
    this.condition = new ConditionHandler(this.triggerConditionConfig, this);
  }

  /**
   *  @function Dependency.prepareEffectsConfig Doku folgt..
   */
  prepareEffectsConfig() {}

  /**
   * @function Dependency.buildEffects Erstellt und speichert die Effekte
   */
  buildEffects() {
    this.effectsConfig.forEach((eConfig) => {
      this.effects.push(new EffectHandler(eConfig, this.messageHandler));
    });
  }

  /**
   * @function Dependency.refresh Refreshed die Attributabhngigkeit (z.B. bei Änderungen) und setzt die Effekte je nachdem, ob die Bedingung erfüllt ist
   */
  refresh() {
    const evalResult = this.condition.evaluate();
    const messages = [];
    messages.push(`${this.condition.getString()}=> ${evalResult.toString()}`);
    if (this.condition.evaluate()) {
      this.effects.forEach((eff) => {
        eff.triggerEffect();
        messages.push(
          `==> trigger : [${this.effects.map((e) => e.getString()).join()}]`
        );
      });
    } else {
      this.effects.forEach((eff) => {
        eff.resetEffects();
        messages.push(
          `==> reset : [${this.effects.map((e) => e.getString()).join()}]`
        );
      });
    }
    DataStore.getHandler().messageHandler.logDebugFormatted(
      "Dependency",
      "refresh",
      "",
      "",
      "",
      messages
    );
  }
}
export default Dependency;
